import { render, staticRenderFns } from "./ReplacementItem.vue?vue&type=template&id=1108fc48"
import script from "./ReplacementItem.vue?vue&type=script&lang=js"
export * from "./ReplacementItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports